import {
    defineMessages
} from "react-intl"

export const messages = defineMessages({
    "search_placeholder": {
        id: "contact.listing.search_placeholder",
        defaultMessage: "Search a contact...",
    },
    "customer_type_placeholder": {
        id: "invoice.listing.customer_type_placeholder",
        defaultMessage: "Customer type",
    },
    "customer_tags_placeholder": {
        id: "invoice.listing.customer_tags_placeholder",
        defaultMessage: "Customer tags",
    },
    "identifier": {
        id: "invoice.listing.headers.id_label",
        defaultMessage: "ID"
    },
    "external_id": {
        id: "invoice.listing.headers.external_id_label",
        defaultMessage: "External ID"
    },
    "created_at": {
        id: "invoice.listing.filters.date.created_at",
        defaultMessage: "Created date",
    },
    "updated_at": {
        id: "invoice.listing.filters.date.updated_at",
        defaultMessage: "Updated date",
    },
    "contact_nameSort": {
        id: "invoice.listing.headers.contact_nameSort",
        defaultMessage: "Contact",
    },
    "location": {
        id: "invoice.listing.headers.location",
        defaultMessage: "Location",
    },
    "contact_firstname": {
        id: "invoice.listing.headers.contact_firstname",
        defaultMessage: "Contact first name",
    },
    "contact_lastname": {
        id: "invoice.listing.headers.contact_lastname",
        defaultMessage: "Contact last name",
    },
    "contact_organization_name": {
        id: "invoice.listing.headers.contact_organization_name",
        defaultMessage: "Contact organization name",
    },
    "contact_type": {
        id: "invoice.listing.headers.contact_type",
        defaultMessage: "Contact type",
    },
    "contact_phonenumber": {
        id: "invoice.listing.headers.contact_phonenumber",
        defaultMessage: "Contact phone number",
    },
    "contact_email": {
        id: "invoice.listing.headers.contact_email",
        defaultMessage: "Contact email",
    },
    "contact_name": {
        id: "invoice.listing.headers.contact_name",
        defaultMessage: "Contact name",
    },
    "contact_id": {
        id: "invoice.listing.headers.contact_id",
        defaultMessage: "Contact id",
    },
    "supplier_name": {
        id: "invoice.listing.headers.supplier_name",
        defaultMessage: "Supplier name",
    },
    "supplier": {
        id: "invoice.listing.headers.supplier",
        defaultMessage: "Supplier",
    },
    "tax_number": {
        id: "invoice.listing.customer_tax_number_placeholder",
        defaultMessage: "Contact tax number",
    },
    "tax_id": {
        id: "invoice.listing.headers.tax_id",
        defaultMessage: "Tax",
    },
    "default_tax": {
        id: "customer.modal.add_form.default_tax_label",
        defaultMessage: "Default tax",
    },
    "most_used_filters": {
        id: "invoice.listing.headers.most_used_filters",
        defaultMessage: "Most used filters",
    },
    "is_archived": {
        id: "invoice.listing.headers.show_archived",
        defaultMessage: "Show archived",
    },
    "recurring_statement_enabled": {
        id: "contact.listing.headers.recurring_statement_enabled",
        defaultMessage: "Recurring statement enabled",
    },
    "recurring_statement_next_creation_date": {
        id: "contact.listing.headers.recurring_statement_next_creation_date",
        defaultMessage: "Recurring statement next creation date",
    },
    "recurring_statement_send_email_enabled": {
        id: "contact.listing.headers.recurring_statement_send_email_enabled",
        defaultMessage: "Recurring statement send email enabled",
    },
    "recurring_statement_capture_payment_enabled": {
        id: "contact.listing.headers.recurring_statement_capture_payment_enabled",
        defaultMessage: "Recurring statement auto capture payment (card on file) enabled",
    },
    "recurring_statement_attach_pdf_enabled": {
        id: "contact.listing.headers.recurring_statement_attach_pdf_enabled",
        defaultMessage: "Recurring statement with attached pdf enabled",
    },

    //organization messages
    "company_id": {
        id: "contact.listing.headers.company",
        defaultMessage: "Company",
    },
    "company_name": {
        id: "contact.listing.headers.company_name",
        defaultMessage: "Company Name",
    },
    "company_phone_number": {
        id: "contact.listing.headers.company_phonenumber",
        defaultMessage: "Company Phone Number",
    },
    "company_tax_number": {
        id: "contact.listing.headers.company_tax_number",
        defaultMessage: "Company Tax Number",
    },
    "company_email": {
        id: "contact.listing.headers.company_email",
        defaultMessage: "Company Email",
    },
    "company_default_tax": {
        id: "customer.modal.add_form.default_tax_label",
        defaultMessage: "Default tax",
    },

})


// WEBPACK FOOTER //
// ./src/common/search-filter/search/contactFilters/messages.ts